import { Flex, Text, Button } from '@chakra-ui/react'
import { Select } from 'components'

import { FiltersT } from 'modules/BioriskMpox/Epidemiology'
import { useContext, useState } from 'react'
import { DataContext } from '../..'
import HorizontalBarChart from '../Charts/HorizontalBarChart'
import { formatData } from '../helpers/formatData'
import CardContainer from 'components/Dashboards/IDATrialsMapDashboard/Cards/CardContainer'
import { Download } from '@carbon/icons-react'
import { exportCardsData } from '../helpers/exportData'
import { handleCountrySelectOnCard } from '../helpers'

const stackByOptions = {
  procurementMechanism: {
    key: 'recipients',
    title: 'Recipients',
  },
  designationA: {
    key: 'designationA',
    title: 'Vaccine vs Treatment',
  },
  candidates: { key: 'candidates', title: 'Candidates' },
  suppliers: { key: 'suppliers', title: 'Developers' },
}

const VaccineDonations = ({ filters }: { filters: FiltersT }) => {
  const [expanded, setExpanded] = useState(false)
  const [stackBy, setStackBy] = useState(stackByOptions.procurementMechanism)
  const { donations, handleCountrySelection } = useContext(DataContext)

  function handleClick(e: any) {
    handleCountrySelectOnCard(handleCountrySelection, e)
  }

  const { chartData, uniqueKeys } = formatData(
    donations?.data,
    'donorAreas',
    stackBy.key,
    filters.nCountries,
    filters.country
  )

  function handleSelect({ label, value }: { label: string; value: string }) {
    setStackBy({ title: label, key: value })
  }

  return (
    <CardContainer
      minWidth='350px'
      expanded={expanded}
      setExpanded={setExpanded}
      width='100%'
    >
      <Flex w='90%' gap={2} justifyContent={'space-between'}>
        <Text fontWeight={'semibold'} fontSize='sm'>
          Donation Pledges
        </Text>
        <Flex mt={-1} alignItems={'center'} gap={2}>
          <Select
            value={{
              value: stackBy.key,
              label: stackBy.title,
            }}
            options={Object.values(stackByOptions).map(({ key, title }) => ({
              label: title,
              value: key,
            }))}
            onChange={handleSelect}
            isMulti={false}
            isSearchable={false}
            backgroundColor='#fff'
            color='#000'
            fontSize={'10px'}
            height='26px'
          />
          <Button
            onClick={() => exportCardsData(donations.data, 'donations')}
            variant={'ghost'}
            w={'24px'}
            h={'24px'}
            p={0}
          >
            <Download size={16} />
          </Button>
        </Flex>
      </Flex>
      <HorizontalBarChart
        isStacked={true}
        expanded={expanded}
        chartData={chartData}
        handleClick={handleClick}
        error={donations?.error}
        isLoading={donations?.isLoading}
        barKeys={uniqueKeys}
      />
    </CardContainer>
  )
}

export default VaccineDonations
